import React from "react"
import { ResponsiveGatsbyImage } from "../ResponsiveGatsbyImage"
import {
  Container,
  InnerContainer,
  Img,
  Category,
  CategoryLink,
  TitleLink,
  Date,
  Description,
  KeepLink,
} from "./editorialBigTeaserStyles"
import moment from "moment"
import ImageOrVideo from "../ImageOrVideo"

export default function EditoriaBigTeaser({
  categories,
  title,
  date,
  excerpt,
  link,
  featuredImage,
  avVideoTeaser,
  imageReverse,
  colourFeatureImage,
}) {
  return (
    <Container imageReverse={imageReverse} className="bigTeaser">
      <Img>
        <ImageOrVideo
          img={featuredImage}
          avVideoTeaser={avVideoTeaser}
          sizes="(min-width: 768px) 33vw, 50vw"
          color={colourFeatureImage}
          rgb={colourFeatureImage}
          style={{ height: "100%", width: "100%" }}
        />
      </Img>

      <InnerContainer imageReverse={imageReverse}>
        {!!categories?.length && (
          <Category>
            {categories.slice(0, 3).map((category, index) => (
              <CategoryLink
                to={`/category/${category.slug}/`}
                key={index}
                dangerouslySetInnerHTML={{ __html: category.name }}
              />
            ))}
          </Category>
        )}
        <TitleLink
          className="title"
          to={link}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <Date>{moment(date).format("ll")}</Date>
        <Description dangerouslySetInnerHTML={{ __html: excerpt }} />
        <KeepLink className="title" to={link}>
          Keep reading
        </KeepLink>
      </InnerContainer>
    </Container>
  )
}
